import React, { useCallback, useEffect, useState } from 'react';

import {
  Box,
  Button,
  Grid,
  Link,
  Typography,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';

import WhatsappSrc from '../../../../assets/img/whatsapp.svg';
// import WhatsappSrc from '../../../../assets/img/whatsapp.png';
import Dropzone from '../../../../components/Dropzone/Dropzone.component';
import SharedDialog from '../../../../components/SharedDialog/SharedDialog.component';
import { appConfig } from '../../../../config/app';
import { IncidentsSides } from '../../../../constants/incidents.constant';
import { useSinisterDataContext } from '../../../../context/sinister/sinister.provider';

const InsideInspectionElement = ({ onAction, step }: any) => (
  <>
    <img
      src={require(`../../../../assets/img/${step?.side}.svg`)}
      // src={require(`../../../../assets/img/${step?.side}.png`)}
      alt="denuncia"
    />
    <Box my={3}>
      <Button variant="contained" color="primary" onClick={onAction}>
        {IncidentsSides[step?.side]?.button}
      </Button>
    </Box>
  </>
);

const OwnDamagePhotos = () => {
  const {
    success,
    errors,
    nextStep,
    sinister_body,
    image_preview,
    updloadPhotos,
  } = useSinisterDataContext();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('sm'));

  const [complaintImage, setComplaintImage] = useState('');
  const [open, setOpen] = useState(false);

  const [sides] = useState(sinister_body.crash.damaged_parts);
  const [currentSide, setCurrentSide] = useState(
    sinister_body.crash.damaged_parts[0]
  );
  const [preview, setPreview] = useState(
    image_preview.find(
      (prev: any) =>
        prev.type === sinister_body.incident_type &&
        prev.photo_type === 'damaged_part' &&
        prev.side === sinister_body.crash.damaged_parts[0].side
    )
  );

  const handlingNextStep = useCallback(() => {
    setCurrentSide((currSide: any) => {
      const updateIndex = sides.findIndex(
        (side: any) => side.side === currSide.side
      );

      if (updateIndex === sides.length - 1) {
        nextStep();
        return currSide;
      } else {
        setPreview(
          image_preview.find(
            (prev: any) =>
              prev.type === sinister_body.incident_type &&
              prev.photo_type === 'damaged_part' &&
              prev.side === sides[updateIndex + 1].side
          )
        );
        return sides[updateIndex + 1];
      }
    });
  }, [nextStep, sides, image_preview, sinister_body]);

  useEffect(() => {
    if (success.photo) {
      handlingNextStep();
    }
  }, [success, handlingNextStep]);

  useEffect(() => {
    if (errors.photo) {
      setOpen(true);
    }
  }, [errors]);

  const handlingNext = (skipped: boolean = false) => {
    if (!skipped) {
      const { incident_type, vehicle_id } = sinister_body;

      updloadPhotos({
        type: incident_type,
        vehicle_id: vehicle_id,
        photo_type: 'damaged_part',
        side: currentSide.side,
        'photo[0]': complaintImage,
      });
    } else {
      handlingNextStep();
    }
  };

  return (
    <>
      <SharedDialog
        open={open}
        onClose={() => setOpen(false)}
        content={
          <Box>
            <Box mb={2}>
              <Typography variant="h6">
                ¡Lo sentimos! no pudimos procesar correctamente tus fotos
              </Typography>
              <Typography variant="body2">
                Podés reintentar en unos instantes o comunicarte con nosotros
                por Whatsapp para cargar tu denuncia.
              </Typography>
            </Box>
          </Box>
        }
        actions={
          <Grid container justify="flex-end">
            <Grid item xs={12} sm={6}>
              <Box m={2} display="flex" alignItems="center">
                <Link
                  href={appConfig?.WHATSAPP_LINK}
                  rel="noopener"
                  target="_blank"
                >
                  <Button variant="outlined" fullWidth color="secondary">
                    <img
                      src={WhatsappSrc}
                      alt="Whatsapp"
                      style={{ marginLeft: '15px' }}
                    />
                    <Typography display="inline">
                      Comunicarme vía Whatsapp
                    </Typography>
                  </Button>
                </Link>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Box m={2}>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={() => setOpen(false)}
                >
                  Entendido
                </Button>
              </Box>
            </Grid>
          </Grid>
        }
      ></SharedDialog>
      <Grid container>
        <Grid item xs={12}>
          <Box my={2}>
            <Typography variant="h6" color="textPrimary">
              {/* <Typography variant="h6" color="primary"> */}
              {IncidentsSides[currentSide.side].title}
            </Typography>
          </Box>
          <Box mb={3}>
            {!matches && (
              <Typography variant="body1">
                Que no esté borrosa, cortada, y ni oscura.
              </Typography>
            )}
          </Box>
        </Grid>
        <Grid item xs={12} md={12}>
          <Grid container justify="center" alignItems="center">
            <Grid item xs={12}>
              <Box m={2}>
                <Dropzone
                  onChange={(file: string) => setComplaintImage(file)}
                  onNext={handlingNext}
                  preview={preview?.['photo[0]']}
                  optional
                  getFile
                  // hideContinueBtn={true}
                >
                  <InsideInspectionElement step={currentSide} />
                </Dropzone>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default OwnDamagePhotos;
